module.exports = __webpack_public_path__ + "static/media/user.fc816301.png";